import { features } from "../lib/content";
import { featureIcons } from "./Icons";

export default function Features() {
  return (
    <section id="features" className="section-pad bg-white">
      <div className="container-page">
        <div className="max-w-2xl">
          <span className="eyebrow">{features.eyebrow}</span>
          <h2 className="h-section mt-4">{features.heading}</h2>
          <p className="lead">{features.subheading}</p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.items.map((feature) => {
            const Icon = featureIcons[feature.icon];
            return (
              <div
                key={feature.title}
                className="card group p-6 shadow-card transition-shadow hover:shadow-lift"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 transition-colors group-hover:bg-brand-500 group-hover:text-white">
                  {Icon ? <Icon /> : null}
                </span>
                <h3 className="mt-5 text-base font-semibold text-ink">{feature.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted">{feature.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
